import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {reduxForm} from 'redux-form/immutable';
import ReCAPTCHA from "react-google-recaptcha";

import {InputField, SelectField} from 'common/fields';

const validate = input => {
	const errors = {};
	if (!input.get('client_card')) {
		errors.client_card = 'Введите № карты';
	}
	if (!input.get('name')) {
		errors.name = 'Введите имя';
	}
	return errors;
};

@reduxForm({
	form: 'bookForm',
	validate,
	enableReinitialize: true,
})
export default class extends Component {
	static propTypes = {
		loading: PropTypes.bool,
		date: PropTypes.string,
		selectedTableId: PropTypes.number,
		selectedIntervals: PropTypes.array,
		handleSubmit: PropTypes.func,
		error: PropTypes.string,
		tableName: PropTypes.string,
		timeFrom: PropTypes.string,
		timeTill: PropTypes.string,
		cardsOnly: PropTypes.bool,
	};

	constructor(props) {
		super(props);
		this.recaptchaRef = React.createRef();
	}

	normalizeCard = value => {
		return value.replace(/[^0-9]/g, '');
	}

	onSubmit = props => {
		const {onSubmit} = this.props;
		this.recaptchaRef.current.executeAsync().then(value => {
      console.log("executeAsync promise - Captcha value:", value);
			onSubmit({
				...props.toJS(),
				recaptchaToken: value,
			}, () => this.recaptchaRef.current.reset());
    });
	};

	render() {
		const {
			tableName,
			timeFrom,
			timeTill,
			error,
			loading,
			handleSubmit,
			cardsOnly,
		} = this.props;

		const peopleOptions = [];
		for (let i=1; i<=9; i++) {
			peopleOptions.push({
				value: i,
				label: i,
			});
		}

		return (
			<form onSubmit={handleSubmit(this.onSubmit)}>
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-3 choice">
						<p>Вы выбрали</p>
						<p><b>{tableName}</b> с <b>{timeFrom}</b> до <b>{timeTill}</b></p>
					</div>
					<div className="col-sm-12 col-md-12 col-lg-9">
						<div className="form-row">
							<div className="form-group col-6 col-sm-4 col-lg-2">
								<label htmlFor="field-people">Кол-во человек</label>
								<SelectField
									id="field-people"
									name="people"
									options={peopleOptions}
									className="form-control"
								/>
							</div>
							{cardsOnly &&
							<div className="form-group col-6 col-sm-4 col-lg-3">
								<label htmlFor="field-card">Номер карты</label>
								<InputField
									id="field-card"
									name="client_card"
									type="text"
									placeholder="0000"
									maxLength="5"
									normalize={this.normalizeCard}
									className="form-control"
								/>
							</div>}
							{!cardsOnly &&
							<div className="form-group col-6 col-sm-4 col-lg-3 phone">
								<label htmlFor="field-card">Номер телефона</label>
								<InputField
									id="field-phone"
									name="phone"
									type="text"
									className="form-control"
								/>
							</div>}
							<div className="form-group col-xs-12 col-sm-4 col-lg-4">
								<label htmlFor="field-name">Ваше имя</label>
								<InputField
									id="field-name"
									name="name"
									type="text"
									className="form-control"
								/>
							</div>
							<div className="col-sm-12 col-md-12 col-lg-3">
								<InputField
									name="table_id"
									type="hidden"
								/>
								<InputField
									name="booked_from"
									type="hidden"
								/>
								<InputField
									name="booked_till"
									type="hidden"
								/>
								<ReCAPTCHA
									ref={this.recaptchaRef}
									size="invisible"
									sitekey="6LcOZ4wqAAAAAB2U2tVTJtV_G1q5vBpAMg2uwrko"
									className="recaptcha-wrapper"
								/>
								<input
									type="submit"
									className="btn btn-block btn-danger custom-bg custom-border"
									value="Забронировать"
									disabled={loading}
								/>
							</div>
						</div>
						{error && <div className='text-center text-danger'>{error}</div>}
					</div>
				</div>
			</form>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/book/FormComponent.js